import { render, staticRenderFns } from "./CancelColorButton.vue?vue&type=template&id=2008c07a"
import script from "./CancelColorButton.vue?vue&type=script&lang=js"
export * from "./CancelColorButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports